import { FC, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { endpoints } from "../../../ApiEndPoints/apiEndPoints";
import { UI_CONSTANTS } from "../../../Constants/constants";
import { storeDataTablePayload } from "../../../Redux/Actions/dataTableActions";
import store from "../../../Store/store";
import { DataTableType } from "../../../Types/editableFamilyGroupType";
import { IColumn } from "../../../Types/gridDataProps";

const ProductHierarchy: FC<DataTableType> = (props: DataTableType) => {
  const user = useSelector((state: any) => state.auth.user);

  const columnDefinition: IColumn[] = [
    {
      name: "Item Number",
      accessor: "SainId",
    },
    {
      name: "Display Item Number",
      accessor: (rowData: any) => {
        return {
          value: rowData?.SkuNumber ? rowData?.SkuNumber : rowData?.CatNumber,
        };
      },
    },
    {
      name: "Description",
      accessor: "Description",
    },
    {
      name: "UOM",
      accessor: (rowData: any) => {
        return {
          value:
            rowData?.Alias === UI_CONSTANTS.SAINSBURYS_SKU ||
            rowData?.Alias === UI_CONSTANTS.SAINSBURYS_PACK
              ? `CS${rowData?.PackSize}`
              : rowData?.Alias === UI_CONSTANTS.ARGOS
              ? (rowData?.PackSize == 1) ? `EA` : `CS${rowData?.PackSize}`
              : rowData?.PackSize,
        };
      },
    },
    {
      name: "Product Group",
      accessor: "ProductType",
    },
    {
      name: "Family Group",
      accessor: "FamilyGroup",
      type: "family-group",
    },
    {
      name: "Family Group Description",
      accessor: "FamilyGroupDescription",
    },
    {
      name: "Business Unit",
      accessor: "BusinessUnitDesc",
    },
    {
      name: "Super Cat",
      accessor: "SuperCatDesc",
    },
    {
      name: "Category",
      accessor: "CategoryDesc",
    },
    {
      name: "Sub Cat",
      accessor: "SubCategoryDesc",
    },
    {
      name: "Segment",
      accessor: "SegmentDesc",
    },
  ];

  useEffect(() => {
    let payload = {
      service: endpoints.searchProductData(),
      columnDefinition: columnDefinition,
      toggleSearchPanel: (e: any) => props.toggleSearchPanel(e),
      isColumnMerge: true,
    };
    store.dispatch(storeDataTablePayload(payload));
  }, []);

  return <></>;
};

export default ProductHierarchy;
